import styled from "styled-components"; 

export const ContainerCardBlueRecepcion = styled.div`
    background-color: var(--color-latex10);
    color: var(--color-white);
    font-weight: 400;
    font-size: 32px;
    width: 90%;
    border-radius: 16px;
    padding: 20px;
    text-align: center;
    span {
        font-weight: bold;
        color: var(--color-white);
    }
`;